import React, { useState } from "react";
import PropTypes from "prop-types"; // Import prop-types
import ThumbUpOutlinedIcon from "@mui/icons-material/ThumbUpOutlined";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import { postAPI } from "../../API/ApiService";
import { BASE_URL } from "../../constant/apiUrl";
import { Box } from "@mui/material";

export default function LikeButton({
  cardId,
  Liked,
  onLikesUpdated,
  setLoading,
  payloadLike,
  setFetch,
  fetch,
}) {
  const [hasLiked, setHasLiked] = useState(Liked);

  const handleLike = async () => {
    const data = {
      id: cardId,
      likes: payloadLike,
    };

    try {
      const response = await postAPI(`${BASE_URL}/rfi/save-metrics`, data);

      if (response?.status === 200) {
        const newLikes = response?.data?.response;

        onLikesUpdated(newLikes.likes); // Call the function passed from the parent to update likes
        setHasLiked(payloadLike);
        setFetch(!fetch);
      } else {
        console.error("Failed to update like status:", response);
      }
    } catch (error) {
      console.error("Error while liking the post:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      onClick={handleLike}
      style={{ cursor: "pointer" }}
      data-testid="button"
    >
      {hasLiked ? (
        <ThumbUpIcon sx={{ height: "20px", width: "20px", fill: "#005CBC" }} />
      ) : (
        <ThumbUpOutlinedIcon
          sx={{ height: "20px", width: "20px", fill: "#005CBC" }}
        />
      )}
    </Box>
  );
}

// Prop Types validation
LikeButton.propTypes = {
  cardId: PropTypes.number.isRequired,
  Liked: PropTypes.bool.isRequired,
  payloadLike: PropTypes.bool.isRequired,
  onLikesUpdated: PropTypes.func.isRequired,
  setLoading: PropTypes.func.isRequired,
  setFetch: PropTypes.func.isRequired,
  fetch: PropTypes.bool.isRequired,
};
